import axios from "axios";
import { withPath } from "library/api/api";
import { deleteHref, getHref, postHref } from "./httpMethods";

export const getDirectDebit = async ({ token }) => {
  try {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const directDebitData = await getHref<any>(
      withPath(`v1/direct-debit/directdebit/${token}`),
    );
    return directDebitData;
  } catch (error) {
    if (
      axios.isAxiosError(error) &&
      error?.response?.data?.type === "NOT_FOUND"
    ) {
      return {
        data: null,
      };
    }

    throw error;
  }
};

export interface PostDirectDebitParams {
  token: string;
  accountName: string;
  jointAccount: string;
  bankName: string;
  bsb: string;
  paymentType: string;
  accountNumber: string;
  paymentAmount: string;
  setErrors: React.Dispatch<
    React.SetStateAction<{ bsb?: string; accountName?: string }>
  >;
}

export const postDirectDebit = ({
  token,
  accountName,
  jointAccount,
  bankName,
  bsb,
  accountNumber,
  paymentType,
  paymentAmount,
}: PostDirectDebitParams) =>
  postHref(
    withPath(
      `v1/direct-debit/directdebit/${token}?push_projected_payment=true`,
    ),
    {
      account_name: accountName,
      joint_account: jointAccount !== "no",
      bank_name: bankName,
      bsb,
      bank_account_number: accountNumber,
      payment_type: paymentType,
      amount: paymentAmount || null,
    },
  );

export const deleteDirectDebit = ({ token }) =>
  deleteHref(withPath(`/v1/direct-debit/directdebit/${token}`));
